import api from "@/services/api";

export default {
  fetchFilesByStakeholder() {
    return api.post(`stakeholder_files/get_stakeholder_files/`);
  },
  fetchStakeholdersFiles() {
    return api.get(`stakeholder_files/`);
  },
  postStakeholderFile(payload) {
    return api.post(`stakeholder_files/`, payload).then(response => response.data);
  },
  deleteStakeholderFile(pk) {
    return api.delete(`stakeholder_files/${pk}`).then(response => response.data);
  }
};
